export const formatPrice = (priceDetail, tradeTypeName) => {
  const { price, currency = "TL" } = priceDetail || {};
  if (tradeTypeName === "Kat Karşılığı") return "Kat Karşılığı";
  const thousand = 1000;
  const oneHundredThousand = 100000;
  const oneMillion = 1000000;
  const oneBillion = 1000000000;

  const millionBreakDown = oneMillion - price === 1;
  const billionBreakDown = oneBillion - price === 1;

  const isPriceLessThanOneHundredThousand = price < oneHundredThousand;
  const isPriceBetweenMillionAndThousand = price >= oneHundredThousand && price < oneMillion && !millionBreakDown;
  const isPriceEqualToMillion = (price >= oneMillion && price < oneBillion && !billionBreakDown) || millionBreakDown;
  const numberFormatterRegex = /\B(?=(\d{3})+(?!\d))/g;

  if (isPriceLessThanOneHundredThousand) {
    return price.toString().replace(numberFormatterRegex, ".") + ` ${currency}`;
  } else if (isPriceBetweenMillionAndThousand) {
    const shortened = Math.floor(price / thousand);
    return shortened + ` Bin ${currency}`;
  } else if (isPriceEqualToMillion) {
    const shortened = price / oneMillion;
    return shortened.toFixed(2) + ` M ${currency}`;
  } else {
    const shortened = price / oneBillion;
    return shortened.toFixed(2) + ` MR ${currency}`;
  }
};

export const formatPriceForProjectPrices = (price) => {
  if (!price) return null;
  const numberPattern = /\d{1,3}(?:\.\d{3})*(?=(?:[^0-9]|$))/g;

  const filteredNumbers = price.match(numberPattern);

  const numberArray = filteredNumbers.map((number) => parseFloat(number.replace(/\./g, "")));
  const resultArray = numberArray.map((number) => formatPrice(number));
  return resultArray.join(" - ");
};

// For floor number
// const getSpecificDigitGroup = (number, length) => {
//   const numberStr = number.toString();
//   const regex = new RegExp("\\d{" + length + "}", "g");

//   const matches = numberStr.match(regex);

//   if (matches) return matches[0];
// };

export const setMapOrListingFinalPath = ({ res = {}, screenType = "listing" }) => {
  if (!res.path) return "";

  if (screenType === "map") {
    const hasQueryParams = res.path.includes("?");
    const mapQueryParamPrefix = hasQueryParams ? "&view_type=map" : "?filtreler=view_type=map";
    return `${res.path}${mapQueryParamPrefix}`;
  }

  if (screenType === "listing") {
    const [basePath, queryString] = res.path.split("?");
    if (!queryString) return res.path;

    const params = queryString
      .split("&")
      .filter(
        (param) =>
          !param.startsWith("view_type=") && !param.startsWith("bottom_left=") && !param.startsWith("top_right=")
      );

    const updatedQuery = params.join("&");
    return updatedQuery ? `${basePath}?${updatedQuery}` : basePath;
  }

  return res.path;
};

export const getListingItems = (listings, projectListings) => {
  const listingItems = listings?.listingCard?.records || [];
  const projectListingItems = projectListings?.projectCards?.records || [];
  return { listingItems, projectListingItems };
};

export const extractValuesFromObject = (data, keys) => {
  const result = {};
  keys.forEach((key) => {
    const foundItem = data?.find((item) => item?.key === key);
    result[key] = foundItem ? foundItem.value : "";
  });
  return result;
};

export const resizeBalloonImage = (source) => {
  const resizedWidth = Math.round(238 * 2);
  const resizedHeight = Math.round(149 * 2);

  let updatedUrl;

  if (source?.includes("/listing/")) {
    updatedUrl = `${source.split("/listing/")[0]}/resize/${resizedWidth}/${resizedHeight}/listing/${
      source.split("/listing/")[1]
    }`;
  } else if (source?.includes("/cms/")) {
    updatedUrl = `${source.split("/cms/")[0]}/cms/resize/${resizedWidth}/${resizedHeight}/${source.split("/cms/")[1]}`;
  } else {
    updatedUrl = source;
  }

  return updatedUrl;
};
